import React from 'react';
import { Clock, Phone, CreditCard, Globe } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import useIsMobile from '@/hooks/useIsMobile';

const ICONS = [Clock, Phone, CreditCard, Globe];

const HowItWorks = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const items = t('how.items', { returnObjects: true });

  return (
    <section className="bg-[#0F0F0F] py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#EAB308] font-semibold mb-3">{t('how.label')}</p>
          <h2 className="text-3xl sm:text-4xl font-light text-white tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {t('how.title')}
          </h2>
          <p className="text-[#A3A3A3] mt-3 text-base max-w-xl mx-auto">{t('how.subtitle')}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div key={item.title}
                {...(!isMobile && { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true }, transition: { duration: 0.5, delay: i * 0.1 } })}
                className="bg-[#1A1A1A] border border-white/5 rounded-2xl p-6 hover:border-white/15 transition-all duration-300"
              >
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#EAB308]/10 border border-[#EAB308]/15 mb-5">
                  <Icon size={22} className="text-[#EAB308]" />
                </div>
                <h3 className="text-base font-semibold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>{item.title}</h3>
                <ul className="space-y-2">
                  {item.details.map((d) => (
                    <li key={d} className="flex items-start gap-2 text-sm text-[#A3A3A3]">
                      <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#EAB308] shrink-0" />
                      {d}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
